import { Switch, Route } from 'react-router-dom';

import { useFeature } from 'FeatureProvider';

import { RolesListPage, RoleCreatePage, RoleEditPage, RoleDuplicatePage } from 'domains/personnel';
import { LicenseGuard } from 'domains/subscription';

import NotFound from 'components/NotFound';
import useUserStore from 'hooks/useUserStore';

import AppRoute from '../PrivateRoute';

/**
 * Roles Routes
 *
 * Route configuration for the Roles domain.
 * Manages all role-related pages and navigation.
 * Uses AppRoute for authentication, permissions, and layout.
 *
 * @returns {React.ReactElement} Roles router component
 */
export const RolesRoutes = (): React.ReactElement => {
  const {
    storeState: { selected: storeSelected },
  } = useUserStore();
  const superUserAccess = useFeature('adminStore');
  const workforceModuleAccess = useFeature('backofficeModuleWorkforce');
  const storeAdminAccess = useFeature('storeAdmin');
  const permissionWorkforceModule =
    (superUserAccess || workforceModuleAccess || storeAdminAccess) && !storeSelected?.isDraft;

  return (
    <LicenseGuard>
      <Switch>
        {/* Roles List - Main page */}
        <AppRoute accessRoute={permissionWorkforceModule} component={RolesListPage} exact path="/roles" />

        {/* Create Role */}
        <AppRoute accessRoute={permissionWorkforceModule} component={RoleCreatePage} exact path="/roles/create" />

        {/* Duplicate Role */}
        <AppRoute
          accessRoute={permissionWorkforceModule}
          component={RoleDuplicatePage}
          exact
          path="/roles/:uuid/duplicate"
        />

        {/* Edit Role */}
        <AppRoute accessRoute={permissionWorkforceModule} component={RoleEditPage} exact path="/roles/:uuid" />

        {/* Not found */}
        <Route component={NotFound} />
      </Switch>
    </LicenseGuard>
  );
};
